import React from 'react';
import KvkkTab from '../components/settings/KvkkTab';

// Eskiden "KVKK" adiyla Ayarlar altindaydi - sistem artik KVKK'nin disinda
// da (goruntu/isitsel kayit izni, sozlesme vb.) farkli onay metinleri
// yonettigi icin isim genisletildi, ve sube muduru de kullandigi icin
// (Ayarlar artik sadece admin-only) kendi sayfasina tasindi.
const ConsentTexts = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Onay Metinleri</h2>
      <KvkkTab />
    </div>
  );
};

export default ConsentTexts;
